<template>
  <div>
    <b-modal
      v-model="isError"
      :active="isError"
      :width="1000"
      full-screen
      height="1500"
      scroll="keep"
      :on-cancel="
        () => {
          isError = false
        }
      "
    >
      <div class="card">
        <div class="card-content">
          <header class="modal-card-head">
            <p class="modal-card-title m-b-0">
              <span><img width="120px" :src="tots_image" /></span>
            </p>

            <button class="delete" type="button" @click="closePopUp"></button>
          </header>

          <template>
            <div>
              <section
                class="container section page-header section is-main-section"
              >
                <error-page></error-page>
              </section>
            </div>
          </template>
        </div>
      </div>
    </b-modal>
    <b-modal
      v-model="isSuccess"
      :active="isSuccess"
      :width="1000"
      full-screen
      height="1500"
      scroll="keep"
      :on-cancel="
        () => {
          isSuccess = false
        }
      "
    >
      <div class="card">
        <div class="card-content">
          <header class="modal-card-head">
            <p class="modal-card-title m-b-0">
              <span><img width="120px" :src="tots_image" /></span>
            </p>

            <button class="delete" type="button" @click="closePopUp"></button>
          </header>

          <template>
            <div>
              <section
                class="container section page-header section is-main-section"
              >
                <thank-you
                  :sendCaptureRespos="sendCaptureRespos"
                  :isPrint="isPrint"
                ></thank-you>
              </section>
            </div>
          </template>
        </div>
      </div>
    </b-modal>
    <material-card
      color="warning"
      icon="mdi-account-cash-outline"
      inline
      title="Franchisee To BrainBees Transfer"
    >
      <v-row>
        <v-col cols="12" md="6" lg="4">
          <label class="font-weight-medium body-2">Select Class</label>
          <v-autocomplete
            class="my-0 py-1"
            :disabled="!!selectedService"
            key="id"
            v-model="selectedClassID"
            placeholder="Select class"
            menu-props="auto"
            :items="classes"
            @change="getAllInfo()"
            item-text="name"
            item-value="id"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <label class="font-weight-medium body-2">Select Service</label>
          <v-autocomplete
            clearable
            class="my-0 py-1"
            key="id"
            v-model="selectedService"
            placeholder="Select Service"
            menu-props="auto"
            @change="getAllInfo()"
            :items="services"
            item-text="name"
            item-value="id"
          >
          </v-autocomplete>
          <!-- <v-card-actions>
          <router-link slot="right" :to="{ name: 'printInvoiceFranchiseeToBB' }">
            <v-btn elevation="1" absolute right top> PRINT INVOICE</v-btn>
          </router-link>
        </v-card-actions> -->
          <!-- <v-btn color="green" @click="">
             PRINT INVOICE
          </v-btn> -->
        </v-col>
      </v-row>
      <v-card-component>
        <v-card-text
          class="pt-0 pr-1"
          :class="{
            'd-block py-3': $vuetify.breakpoint.xs,
            'd-flex align-center': $vuetify.breakpoint.smAndUp
          }"
        >
          <v-text-field
            :class="{
              'mr-0': $vuetify.breakpoint.xs,
              'mr-5': $vuetify.breakpoint.smAndUp
            }"
            v-model="search"
            append-icon="mdi-magnify"
            class="ml-auto mb-2"
            label="Search"
            hide-details
            single-line
            style="max-width: 350px"
            @input="customSearch(search)"
          />
        </v-card-text>
        <!-- <div> -->
        <v-row key="4">
          <v-col cols="12">
            <template>
              <v-row>
                <v-col cols="12" lg="12" sm="12">
                  <v-simple-table vertical disable-pagination>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-Subtitle 2 justify-center">
                            Student Details
                          </th>
                         <th class="text-Subtitle 2 justify-center">
                            Virtual Order
                          </th>
                          <th>
                            <div class="text-Subtitle"> Order Payment </div>
                            <div class="d-flex justify-end">
                              <v-card color="green subtitle-text">
                                <v-card-subtitle>
                                  Total Order (<span
                                    class="mdi mdi-currency-inr"
                                  ></span
                                  >{{
                                    Number(totalAmountOrder).toFixed(2)
                                  }})</v-card-subtitle
                                >
                              </v-card>
                            </div>
                          </th>
                          <th>
                            <v-row class="text-Subtitle 2">
                              Facilitation Fee Payment
                            </v-row>
                            <v-row class="d-flex justify-end">
                              <v-card color="green subtitle-text">
                                <v-card-subtitle>
                                  Total Facilitation Fee (<span
                                    class="mdi mdi-currency-inr"
                                  ></span
                                  >{{
                                    Number(totalAmountRoyalty).toFixed(2)
                                  }})</v-card-subtitle
                                >
                              </v-card>
                            </v-row>
                            <!-- <v-row justify="end ">
                                <v-card small dark  color="primary">
                                  Total Royalty (<span class="mdi mdi-currency-inr"></span>{{ Number(totalAmountRoyalty).toFixed(2) }})
                                </v-card>
                              </v-row> -->
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(rows, index) in searchFilterArray"
                          :key="index"
                        >
                          <td>
                            <v-checkbox
                              class="shrink mr-0 mt-0"
                              v-model="rows.isChecked"
                              @click="checkedFun(rows)"
                              hide-details
                            ></v-checkbox>
                            <br />Enquiry Code: {{ rows.enquiryCode }}<br />

<div v-if="rows.fatherName">Parent Name: {{ rows.fatherName }}</div>
<div v-else-if="rows.guardianName">Guardian Name: {{ rows.guardianName }}</div>
<div v-else>-</div>
<div v-if="rows.fatherEmailID">Parent Email: {{ rows.fatherEmailID }}</div>
<div v-else-if="rows.guardianEmailID">Guardian Email: {{ rows.guardianEmailID }}</div>
<div v-else>-</div>
<!--<br />Enrollment Code: {{ rows.enrollmentCode }} -->
<div>Student Name: {{ rows.studentFirstName }} </div><br />
                          </td>
 <td>
                            <div v-if="rows.assignVirtualOrderID">
                              <v-simple-table
                                vertical
                                disable-pagination
                                v-if="rows.orders.length > 0"
                              >
                                <template v-slot:default>
                                  <thead>
                                    <tr>

                                      <th>KIT Name</th>
                                      <th>Amount</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="element in rows.orders"
                                                    :key="element.id" >

                                      <td>
                                        {{ element.assignVirtualOrder.kitType }}
                                      </td>

                                      <td>
                                        {{ element.assignVirtualOrder.amount }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </div>
                          </td>

                          <td>
                            <div v-if="rows.orders">
                              <v-simple-table
                                vertical
                                disable-pagination
                                v-if="rows.orders.length > 0"
                              >
                                <template v-slot:default>
                                  <thead>
                                    <tr>
                                      <!-- <th
                                        class="text-Subtitle 2 justify-center"
                                      >
                                        Order Info
                                      </th> -->

                                      <th>KIT NAME</th>
                                      <th>Amount</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <!-- <td>
                                        <v-menu
                                          :close-on-content-click="false"
                                          open-on-hover
                                          :nudge-width="0"
                                          offset-y
                                        >
                                          <template
                                            v-slot:activator="{ on, attrs }"
                                          >
                                            <v-icon
                                              color="green"
                                              right
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              mdi-information
                                            </v-icon>
                                          </template>

                                          <v-card>
                                            <v-simple-table>
                                              <template v-slot:default>
                                                <thead>
                                                  <tr>
                                                    <th class="text-center">
                                                      Pay Now
                                                    </th>
                                                    <th class="text-center">
                                                      Kit Name
                                                    </th>
                                                    <th class="text-center">
                                                      Amount
                                                    </th>
                                                    <th class="text-center">
                                                      Amount Paid
                                                    </th>

                                                    <th class="text-center">
                                                      Amount Due
                                                    </th>
                                                    <th class="text-center">
                                                      Amount To Pay
                                                    </th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  <tr
                                                    v-for="element in rows.orders"
                                                    :key="element.id"
                                                  >
                                                    <td align="center">
                                                      <v-checkbox
                                                        class="shrink mr-0 mt-0"
                                                        readonly
                                                        :value="true"
                                                        v-model="
                                                          element.isChecked
                                                        "
                                                        :disabled="
                                                          element.isCompulsory
                                                        "
                                                        hide-details
                                                      ></v-checkbox>
                                                    </td>
                                                    <td align="center">
                                                      {{ element.kitType }}
                                                    </td>
                                                    <td align="center">
                                                      {{
                                                        Number(
                                                          element.amount
                                                        ).toFixed(2)
                                                      }}
                                                    </td>
                                                    <td align="center">
                                                      {{
                                                        Number(
                                                          element.amountPaid
                                                        ).toFixed(2)
                                                      }}
                                                    </td>
                                                    <td align="center">
                                                      {{
                                                        Number(
                                                          element.amountDue
                                                        ).toFixed(2)
                                                      }}
                                                    </td>
                                                    <td align="center">
                                                      {{
                                                        Number(
                                                          element.payableAmtOrder
                                                        ).toFixed(2)
                                                      }}
                                                    </td>
                                                  </tr>
                                                </tbody>
                                              </template>
                                            </v-simple-table>
                                          </v-card>
                                        </v-menu>
                                      </td> -->
                                      <td> {{ rows.orders[0].kitType }}
                                        <!-- CURRICULUM_KIT_1 -->
                                        <!-- <v-text-field
                                          readonly
                                          v-model="rows.positionOrder"
                                          class="centered-input"
                                        >
                                          <v-icon
                                            :disabled="!rows.isChecked"
                                            slot="append"
                                            color="green"
                                            @click="
                                              changeInstallments(
                                                'plus',
                                                rows,
                                                false
                                              )
                                            "
                                          >
                                            mdi-plus</v-icon
                                          >
                                          <v-icon
                                            :disabled="!rows.isChecked"
                                            slot="prepend"
                                            color="red"
                                            @click="
                                              changeInstallments(
                                                'minus',
                                                rows,
                                                false
                                              )
                                            "
                                          >
                                            mdi-minus
                                          </v-icon>
                                        </v-text-field> -->
                                      </td>

                                      <td>
                                        {{ rows.totalAmountPayableOrder }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </template>
                              </v-simple-table>
                            </div>
                          </td>
                          <td>
                            <v-simple-table
                              v-if="rows.royalties.length > 0"
                              vertical
                              disable-pagination
                            >
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-Subtitle 2 justify-center">
                                      Facilitation Fee Info
                                    </th>

                                    <th>Facilitation Fee</th>
                                    <th>Amount</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <v-menu
                                        :close-on-content-click="false"
                                        open-on-hover
                                        :nudge-width="0"
                                        offset-y
                                      >
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <v-icon
                                            color="green"
                                            right
                                            v-bind="attrs"
                                            v-on="on"
                                          >
                                            mdi-information
                                          </v-icon>
                                        </template>

                                        <v-card>
                                          <v-simple-table>
                                            <template v-slot:default>
                                              <thead>
                                                <tr>
                                                  <th class="text-center">
                                                    Pay Now
                                                  </th>
                                                  <th class="text-center">
                                                    Installment Name
                                                  </th>
                                                  <th class="text-center">
                                                    Amount
                                                  </th>
                                                  <th class="text-center">
                                                    Amount Due
                                                  </th>
                                                  <th
                                                    class="text-center"
                                                    v-if="!isIGST"
                                                  >
                                                    CGST
                                                  </th>
                                                  <th
                                                    class="text-center"
                                                    v-if="!isIGST"
                                                  >
                                                    SGST
                                                  </th>
                                                  <th
                                                    class="text-center"
                                                    v-if="isIGST"
                                                  >
                                                    IGST
                                                  </th>
                                                  <th class="text-center">
                                                    TDS
                                                  </th>
                                                  <th class="text-center">
                                                    Amount Paid
                                                  </th>
                                                  <th class="text-center">
                                                    Amount To Pay
                                                  </th>
                                                  <th class="text-center">
                                                    Due Date
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                <tr
                                                  v-for="element in rows.royalties"
                                                  :key="element.id"
                                                >
                                                  <td align="center">
                                                    <v-checkbox
                                                      class="shrink mr-0 mt-0"
                                                      readonly
                                                      :value="true"
                                                      v-model="
                                                        element.isChecked
                                                      "
                                                      :disabled="
                                                        element.isCompulsory
                                                      "
                                                      hide-details
                                                    ></v-checkbox>
                                                  </td>
                                                  <td align="center">
                                                    {{ element.name }}
                                                  </td>
                                                  <td align="center">
                                                    {{
                                                      Number(
                                                        element.amountRoyalty
                                                      ).toFixed(2)
                                                    }}
                                                  </td>
                                                  <td align="center">
                                                    {{
                                                      Number(
                                                        element.amountRoyaltyDue
                                                      ).toFixed(2)
                                                    }}
                                                  </td>
                                                  <td
                                                    align="center"
                                                    v-if="!isIGST"
                                                  >
                                                    {{
                                                      Number(
                                                        element.cGSTAmtRoyalty
                                                      ).toFixed(2)
                                                    }}
                                                  </td>
                                                  <td
                                                    align="center"
                                                    v-if="!isIGST"
                                                  >
                                                    {{
                                                      Number(
                                                        element.sGSTAmtRoyalty
                                                      ).toFixed(2)
                                                    }}
                                                  </td>
                                                  <td
                                                    align="center"
                                                    v-if="isIGST"
                                                  >
                                                    {{
                                                      Number(
                                                        element.iGSTAmtRoyalty
                                                      ).toFixed(2)
                                                    }}
                                                  </td>
                                                  <td align="center">
                                                    {{
                                                      Number(
                                                        element.TDSAmtRoyalty
                                                      ).toFixed(2)
                                                    }}
                                                  </td>
                                                  <td align="center">
                                                    {{
                                                      Number(
                                                        element.amountRoyaltyPaid
                                                      ).toFixed(2)
                                                    }}
                                                  </td>
                                                  <td align="center">
                                                    {{
                                                      Number(
                                                        element.payableAmtRoyalty
                                                      ).toFixed(2)
                                                    }}
                                                  </td>
                                                  <td align="center">
                                                    {{
                                                      new Date(
                                                        element.dueDateRoyalty
                                                      )
                                                    }}
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </template>
                                          </v-simple-table>
                                        </v-card>
                                      </v-menu>
                                    </td>
                                    <td>
                                      <v-text-field
                                        readonly
                                        v-model="rows.position"
                                        class="centered-input"
                                      >
                                        <v-icon
                                          :disabled="!rows.isChecked"
                                          slot="append"
                                          color="green"
                                          @click="
                                            changeInstallments('plus', rows)
                                          "
                                        >
                                          mdi-plus</v-icon
                                        >
                                        <v-icon
                                          :disabled="!rows.isChecked"
                                          slot="prepend"
                                          color="red"
                                          @click="
                                            changeInstallments('minus', rows)
                                          "
                                        >
                                          mdi-minus
                                        </v-icon>
                                      </v-text-field>
                                    </td>

                                    <td>
                                      {{ rows.totalAmountPayableRoyalty }}
                                    </td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
            </template>
          </v-col>
        </v-row>
        <!-- </div> -->
      </v-card-component>
      <v-snackbar v-model="snackbar" :timeout="snackbarTimeout">
        {{ snackbarMsg || 'Welcome' }}

        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <v-row class="d-flex justify-end">
        <v-col cols="12" md="4" lg="3">
          <!-- <v-card-actions class="d-flex justify-end"> -->
          <v-card
            rounded="lg"
            elevation="4"
            width="300"
            height="163"
            color="green"
            dark
          >
            <v-card-title
              ><v-icon class="mr-3" size="50" color="white" left
                >mdi-wallet</v-icon
              >Pay Using Wallet</v-card-title
            >
            <v-card-subtitle class="pl-6"
              ><span class="body-2 white--text font-weight-medium"
                >(Wallet Balance:</span
              ><span class="white--text mdi mdi-currency-inr body-1"
                >{{ walletBalance }})</span
              ></v-card-subtitle
            >
            <v-card-actions>
              <v-btn
                absolute
                bottom
                left
                text
                class="disable-pointer ma-0 pa-0"
              >
                <span class="body-1 text-capitalize font-weight-bold"
                  >Amount:</span
                ><span class="mdi mdi-currency-inr"></span
                >{{ Number(totalAmountToPay).toFixed(2) }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                :disabled="!totalAmountToPay  || walletBalance < totalAmountToPay || walletBalance <= 0"
                absolute
                bottom
                right
                class="pa-0 ma-0"
                color="primary"
                elevation="1"
                @click="walletPay"
              >
                <v-icon left>mdi-arrow-right-bold</v-icon>
                Pay
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <!-- <v-col cols="12" md="4" lg="3">
          <v-card
            color="info"
            dark
            rounded="lg"
            elevation="4"
            width="300"
            height="163"
          >
            <v-card-title
              ><v-icon class="mr-3" size="50" color="color" left
                >mdi-credit-card</v-icon
              >Pay Online</v-card-title
            >
            <v-card-actions>
              <v-btn
                absolute
                bottom
                left
                text
                class="disable-pointer ma-0 pa-0"
              >
                <span class="body-1 text-capitalize font-weight-bold"
                  >Amount:</span
                ><span class="mdi mdi-currency-inr"></span
                >{{ Number(totalAmountToPay).toFixed(2) }}
              </v-btn>
              <v-spacer></v-spacer>

              <v-btn
                :disabled="!totalAmountToPay"
                absolute
                bottom
                right
                class="pa-0 ma-0"
                color="primary"
                elevation="1"
                @click="Pay"
              >
                <v-icon left>mdi-arrow-right-bold</v-icon>
                Pay
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col> -->
      </v-row>
    </material-card>
    <dialog-alert
      :dialogObj="dialogObj"
      v-model="dialogObj.show"
      @clicked="dialogClicked"
    ></dialog-alert>
  </div>
</template>

<script>
import constants from '@/utils/constants'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import ThankYou from '../Fees/payment/thankYou'
import ErrorPage from '../Fees/payment/error'
import DialogAlert from '@/components/template/DialogAlert'
import moment from 'moment'

export default {
  name: 'PlanAssignInstallmentList',
  components: {
    MaterialCard,
    VCardComponent,
    ThankYou,
    ErrorPage,
    DialogAlert
  },
  props: ['referenceID'],
  data () {
    return {
      dialogObj: {
        id: '',
        title: '',
        acceptName: '',
        rejectName: '',
        subtitle: '',
        show: false,
        params: {},
        isNo: true,
        isLoadingYes: false,
        isLoadingNo: false,
        types: {
          payment: 'WALLET'
        },
        isSubTHtml: false
      },
      isPrint: false,
      searchFilterArray: [],
      search: '',
      inProgress: false,
      sendCaptureRespos: [],
      isRecipt: false,
      disable: true,
      selectedRows: [],
      selecteditem: '',
      // dialog: false,
      snackbar: false,
      limitCallBack: 0,
      snackbarMsg: '',
      snackbarTimeout: 2000,

      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      paginated: false,
      gstType: 'IGST',
      isGST: false,
      isIGST: true,
      isConcession: false,
      loadingComponent: null,
      totalAmountRoyalty: 0,
      totalAmountOrder: 0,
      totalVirtualAmountOrder: 0,
      assignVirtualOrderID: '',
      assignKitOrderID: '',
      totalAmountToPay: 0,
      isSuccess: false,
      isError: false,
      isSelected: '',
      sumArray: [],
      breakUpData: [],
      feeTypeNaming: '',
      studentInfo: null,
      walletBalance: null,
      changeRows: [],
      classes: [],
      selectedClassID: '',
      orderID: '',
      services: [],
      selectedService: ''
    }
  },
  beforeCreate () {
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', `${constants.RAZORPAY.JS}`)
    document.head.appendChild(recaptchaScript)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.beforePageDestroyed)
    window.removeEventListener('unload', this.beforePageDestroyed)
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  async created () {
    window.addEventListener('beforeunload', this.beforePageDestroyed)
    window.addEventListener('unload', this.beforePageDestroyed)
    await this.onFranchiseeChange()
  },
  methods: {
    beforePageDestroyed: async function (e) {
      console.log('beforePageDestroyedPayment ONINE')
      if (this.orderID) {
        e.returnValue = ''
        await this.reject().catch((err) => {
          console.log(err)
        })
        e.preventDefault()
        e.returnValue = false // Seems require this for Chrome
      }
    },
    reject: async function () {
      if (!this.orderID) {
        return
      }
      try {
        this.isLoading = true
        await http.patch(
          `${constants.API_URL}/api/payments/online/reject/order`,
          { orderID: this.orderID }
        )
        this.isLoading = false

        this.orderID = ''

        this.$dialog.info({
          text: `Online Payment Rejected !!`,
          title: 'Rejected'
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)

        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    customSearch: function (value) {
      if (_.isEmpty(value)) {
        this.searchFilterArray = this.infoEnquiriesCal
      } else {
        this.searchFilterArray = _.filter(
          this.infoEnquiriesCal,
          (item) =>
            (item &&
              item.enquiryCode &&
              item.enquiryCode.toLowerCase().search(value.toLowerCase()) >=
                0) ||
            (item &&
              item.enrollmentCode &&
              item.enrollmentCode.toLowerCase().search(value.toLowerCase()) >=
                0) ||
            (item &&
              item.studentFirstName.toLowerCase().search(value.toLowerCase()) >=
                0)
        )
      }
    },
    checkedFun: function (val) {
      if (val.isChecked) {
        this.changeRows.push(val)
      } else {
        const findIndex = this.changeRows.findIndex((obj) => obj.id === val.id)
        findIndex !== -1 && this.changeRows.splice(findIndex, 1)
      }

      this.calculatePayAmount(this.changeRows)
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
      if (this.franchiseeID) {
        await this.getClassList()
        await this.walletBalanceFunc()
        if (this.selectedClassID || this.selectedService) {
          await this.getAllInfo()
        }
        await this.getServiceTypes()
      }
    },
    closePopUp () {
      this.isSuccess = false
      this.onFranchiseeChange()
    },
    openSnackbar (msg) {
      if (!this.snackbar) {
        this.snackbarMsg = msg
        this.snackbar = true
        this.limitCallBack--
      } else {
        // Usage!
        if (this.limitCallBack < 1) {
          this.limitCallBack++
          setTimeout(this.openSnackbar(msg), this.snackbarTimeout)
        }
      }
    },
    changeInstallments: function (type, item, isRoyalty = true) {
      if (isRoyalty) {
        if (type === 'plus') {
          if (item.position >= item.maxPosition) {
            item.position = item.maxPosition
            this.openSnackbar('All due installments are selected.')
          } else {
            for (let ele of item.royalties) {
              if (ele.isChecked === false) {
                ele.isChecked = true
                item.position += 1
                break
              }
            }
          }
        } else {
          let currentDate = moment().format('YYYY-MM-DD')
          if (item.position <= item.minPosition) {
            item.position = item.minPosition
            this.openSnackbar(
              'Minimum due till dates installments are selected.'
            )
          } else {
            for (let i = item.royalties.length - 1; i >= 0; i--) {
              let ele = item.royalties[i]
              let dueDate = moment(ele.dueDateRoyalty).format('YYYY-MM-DD')
              if (
                ele.isChecked === true &&
                moment(currentDate).isBefore(dueDate)
              ) {
                ele.isChecked = false
                item.position = item.position - 1
                break
              }
            }
          }
        }
      } else {
        if (type === 'plus') {
          if (item.positionOrder >= item.maxPositionOrder) {
            item.positionOrder = item.maxPositionOrder
            this.openSnackbar('All due installments are selected.')
          } else {
            item.positionOrder = item.positionOrder + 1
          }
        } else {
          if (item.positionOrder <= item.minPositionOrder) {
            item.positionOrder = item.minPositionOrder
            this.openSnackbar(
              'Minimum due till dates installments are selected.'
            )
          } else {
            item.positionOrder = item.positionOrder - 1
          }
        }
      }
      this.calculatePayAmount(this.changeRows)
    },

    calculatePayAmount (arrayInfo) {
      console.log('Array before ', arrayInfo)
      this.totalAmountRoyalty = 0
      this.totalAmountOrder = 0
      this.totalVirtualAmountOrder = 0
      this.totalAmountToPay = 0
      _.forEach(arrayInfo, (item) => {
        item.checkedRows = []
        item.totalAmountRoyalty = 0
        item.totalAmountDueRoyalty = 0
        item.totalConcessionRoyalty = 0
        item.totalAmountPayableRoyalty = 0
        item.totalAmountTotalPaidRoyalty = 0
        item.totalIGSTRoyalty = 0
        item.totalCGSTRoyalty = 0
        item.totalSGSTRoyalty = 0
        item.totalTDSRoyalty = 0
        item.checkedRowsOrder = []
        item.totalAmountOrder = 0
        item.totalVirtualAmountOrder = 0
        item.assignVirtualOrderID = ''
        item.assignKitOrderID = ''
        item.totalAmountDueOrder = 0
        item.totalAmountPayableOrder = 0
        item.totalAmountPaidOrder = 0

        _.forEach(item.royalties, (itemChild, indexChild) => {
          // if (item.position > indexChild) {
          let currentDate = moment().format('YYYY-MM-DD')
          let dueDate = moment(itemChild.dueDateRoyalty).format('YYYY-MM-DD')
          if (moment(currentDate).isAfter(dueDate) || itemChild.isChecked) {
            // Due date past
            itemChild.isChecked = true
            item.totalAmountRoyalty = this.addTwoNumber(
              item.totalAmountRoyalty,
              itemChild.amountRoyalty
            )
            item.totalAmountDueRoyalty = this.addTwoNumber(
              item.totalAmountDueRoyalty,
              itemChild.amountRoyaltyDue
            )
            item.totalConcessionRoyalty = this.addTwoNumber(
              item.totalConcessionRoyalty,
              itemChild.amountRoyaltyConcession
            )
            item.totalAmountPayableRoyalty = this.addTwoNumber(
              item.totalAmountPayableRoyalty,
              itemChild.payableAmtRoyalty
            )
            item.totalAmountTotalPaidRoyalty = this.addTwoNumber(
              item.totalAmountTotalPaidRoyalty,
              itemChild.amountRoyaltyPaid
            )
            item.totalIGSTRoyalty = this.addTwoNumber(
              item.totalIGSTRoyalty,
              itemChild.iGSTAmtRoyalty
            )
            item.totalCGSTRoyalty = this.addTwoNumber(
              item.totalCGSTRoyalty,
              itemChild.cGSTAmtRoyalty
            )
            item.totalSGSTRoyalty = this.addTwoNumber(
              item.totalSGSTRoyalty,
              itemChild.sGSTAmtRoyalty
            )
            item.totalTDSRoyalty = this.addTwoNumber(
              item.totalTDSRoyalty,
              itemChild.TDSAmtRoyalty
            )
            // itemChild.isCompulsory = true
            // console.log(`${itemChild.name} || ${dueDate} || ${currentDate}`)
            item.checkedRows.push(itemChild.id)
          }
          // else {
          // itemChild.isCompulsory = false
          // itemChild.isChecked = false
          // }
          // console.log(`${item.position} > ${indexChild}`)
          // itemChild.isChecked = true
          // item.totalAmountRoyalty = this.addTwoNumber(item.totalAmountRoyalty, itemChild.amountRoyalty)
          // item.totalAmountDueRoyalty = this.addTwoNumber(item.totalAmountDueRoyalty, itemChild.amountRoyaltyDue)
          // item.totalConcessionRoyalty = this.addTwoNumber(item.totalConcessionRoyalty, itemChild.amountRoyaltyConcession)
          // item.totalAmountPayableRoyalty = this.addTwoNumber(item.totalAmountPayableRoyalty, itemChild.payableAmtRoyalty)
          // item.totalAmountTotalPaidRoyalty = this.addTwoNumber(item.totalAmountTotalPaidRoyalty, itemChild.amountRoyaltyPaid)
          // item.totalIGSTRoyalty = this.addTwoNumber(item.totalIGSTRoyalty, itemChild.iGSTAmtRoyalty)
          // item.totalCGSTRoyalty = this.addTwoNumber(item.totalCGSTRoyalty, itemChild.cGSTAmtRoyalty)
          // item.totalSGSTRoyalty = this.addTwoNumber(item.totalSGSTRoyalty, itemChild.sGSTAmtRoyalty)
          // item.totalTDSRoyalty = this.addTwoNumber(item.totalTDSRoyalty, itemChild.TDSAmtRoyalty)
          // if (item.isChecked) {
          //   item.checkedRows.push(itemChild.id)
          // }
          // } else {
          //   itemChild.isChecked = false
          // }
          return itemChild
        })

        _.forEach(item.orders, (itemChild, indexChild) => {
          if (item.positionOrder > indexChild) {
            itemChild.isChecked = true
            item.totalAmountOrder = this.addTwoNumber(
              item.totalAmountOrder,
              itemChild.amount
            )
            item.totalVirtualAmountOrder = this.addTwoNumber(
              item.totalVirtualAmountOrder,
              (itemChild.assignVirtualOrder && itemChild.assignVirtualOrder.amount) ? itemChild.assignVirtualOrder.amount : 0
            )
            item.assignVirtualOrderID = (itemChild.assignVirtualOrder && itemChild.assignVirtualOrder.id) ? itemChild.assignVirtualOrder.id : ''
            item.assignKitOrderID = (itemChild.assignVirtualOrder && itemChild.assignVirtualOrder.assignOrderID) ? itemChild.assignVirtualOrder.assignOrderID : ''

            item.totalAmountDueOrder = this.addTwoNumber(
              item.totalAmountDueOrder,
              itemChild.amountDue
            )

            item.totalAmountPayableOrder = this.addTwoNumber(
              item.totalAmountPayableOrder,
              itemChild.payableAmtOrder
            )
            item.totalAmountPaidOrder = this.addTwoNumber(
              item.totalAmountPaidOrder,
              itemChild.amountPaid
            )
            if (item.isChecked) {
              item.checkedRowsOrder.push(itemChild.id)
            }
          } else {
            itemChild.isChecked = false
          }
          return itemChild
        })
        if (item.isChecked) {
          this.assignVirtualOrderID = item.assignVirtualOrderID
          this.assignKitOrderID = item.assignKitOrderID
          this.totalVirtualAmountOrder = item.totalVirtualAmountOrder

          this.totalAmountRoyalty = this.addTwoNumber(
            item.totalAmountPayableRoyalty,
            this.totalAmountRoyalty
          )
          this.totalAmountOrder = this.addTwoNumber(
            item.totalAmountPayableOrder,
            this.totalAmountOrder
          )

          this.totalAmountOrder = this.addTwoNumber(
            item.totalVirtualAmountOrder,
            this.totalAmountOrder
          )
        }
        return item
      })

      this.totalAmountToPay = this.addTwoNumber(
        this.totalAmountRoyalty,
        this.totalAmountOrder
      )
    },

    getAllInfo: async function () {
      try {
        if (!this.selectedService && !this.selectedClassID) {
          // Class or service both are not selected!
          return
        }
        this.changeRows = []
        let obj = {
          franchiseeID: this.franchiseeID,
          academicYearID: this.academicYearID,
          classID: this.selectedClassID
        }
        if (this.selectedService) {
          this.selectedClassID = ''
          obj.classID = ''
          obj.serviceTypeID = this.selectedService
        }
        if (this.selectedClassID) {
          this.selectedService = ''
        }
        this.loadingComponent = this.$buefy.loading.open()
        let response = await http.post(
          `${constants.API_URL}/api/students/royalty-kits`,
          obj
        )
        this.infoEnquiriesCal = response.data.enquiriesCal
        this.infoEnquiriesCal.map((obj) => {
          obj.isChecked = false
        })
        this.totalAmountOrder = 0
        this.totalAmountRoyalty = 0
        this.gstType = response.data.gstType
        this.totalAmountRoyalty = response.data.orderTotal
        this.totalAmountOrder = response.data.royaltyTotal
        if (this.selectedService) {
          this.searchFilterArray = this.infoEnquiriesCal
        } else {
          this.searchFilterArray = _.filter(
            this.infoEnquiriesCal,
            (a) => a.enrollmentCode
          )
        }

        this.calculatePayAmount(this.infoEnquiriesCal)

        // this.headers = this.getHeaders()
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    addTwoNumber (num1, num2) {
      return this.toFixed(Number(num1) + Number(num2))
    },
    toFixed (number, length = 2) {
      return Number(Number(number).toFixed(length))
    },
    getClassList: async function () {
      try {
        this.isLoading = true

        let response = await http.get(
          `${constants.API_URL}/api/student/all-count?franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&isAllValue=true`
        )
        const data = response.data
        this.classes = data
        console.log('dataClass--', this.classes)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getServiceTypes: async function () {
      try {
        this.isLoading = true
        let response = await http.get(
          `${constants.API_URL}/api/service/type/list`,
          {
            params: {
              franchiseeID: this.franchiseeID,
              academicYearID: this.academicYearID
            }
          }
        )
        const data = response.data
        this.services = data
        console.log('services--', this.services)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    captureResponse: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()

        const response = await http.post(
          `${constants.API_URL}/api/payments/order`,
          {
            referenceID: this.referenceID,
            assignFeeInstallmentID: this.checkedRows,
            amount: this.totalAmountToPay,
            isPortal: true
          }
        )
        this.orderID = response.data.orderID
        return response
        // this.Pay(event, response.data)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('error in fetching data : ', errorMessage)
        this.isError = true
        throw errorMessage
      } finally {
        this.loadingComponent.close()
      }
    },
    onOkay: async function (orderID) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        // this.sendCaptureRespos = await http.post(`${constants.API_URL}/api/payments/capture`, payLoad)
        let assignKitOrderIDArray = []
        let assignVirtualOrderIDArray = []

        _.map(this.changeRows, (obj) => {
          if (obj.assignKitOrderID) {
            assignKitOrderIDArray.push(obj.assignKitOrderID)
          }
          if (obj.assignVirtualOrderID) {
            assignVirtualOrderIDArray.push(obj.assignVirtualOrderID)
          }
        })

        this.sendCaptureRespos = await http.post(
          `${constants.API_URL}/api/payments/franchisee/wallet/capture`,
          {
            orderID: orderID,
            isService: !!this.selectedService,
            assignKitOrderID: assignKitOrderIDArray,
            assignVirtualOrderID: assignVirtualOrderIDArray
          }
        )
        this.orderID = ''
        this.loadingComponent.close()
        if (this.sendCaptureRespos.data.success === 200) {
          await this.getAllInfo()
          await this.walletBalanceFunc()
          return this.$buefy.dialog.alert({
            type: 'is-Suceess',
            message: 'Payment Captured Successfully',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        } else {
          await this.reject()
        }
        // this.sendCaptureRespos = await http.get(`${constants.API_URL}/api/invoice/${this.sendCaptureRespos.data.paymentOrderData.id}`)
        // this.isSuccess=true
        // this.$router.push({ name: 'invoice' })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        await this.reject()
        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    Pay: async function (event) {
      if (this.changeRows.length === 0) {
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'Please select at least one installment',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
      if (this.totalAmountToPay <= 0) {
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'Minimum amount 1 Rupee for procced',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
      try {
        let paymentData = []

        _.map(this.changeRows, (obj) => {
          let studentOrder = { enquiryID: obj.id }
          if (!_.isEmpty(obj.checkedRows)) {
            studentOrder.assignFeeInstallmentID = obj.checkedRows
          }
          if (!_.isEmpty(obj.checkedRowsOrder)) {
            studentOrder.assignOrderID = obj.checkedRowsOrder
          }
          if (!_.isEmpty(obj.checkedRowsOrder) || !_.isEmpty(obj.checkedRows)) {
            paymentData.push(studentOrder)
          }
        })
        let payLoad = {
          franchiseeID: this.franchiseeID,
          classID: this.selectedClassID ? this.selectedClassID : null,
          serviceTypeID: this.selectedService ? this.selectedService : '',
          academicYearID: this.academicYearID,
          amount: Number(this.totalAmountToPay),
          students: paymentData
        }

        this.loadingComponent = this.$buefy.loading.open()
        const resultantObj = await http.post(
          `${constants.API_URL}/api/payments/franchisee/order`,
          payLoad
        )
        this.orderID = resultantObj.data.orderID

        this.loadingComponent.close()
        // const resultantObj = await this.captureResponse()

        let self = this
        var options = {
          key: `${constants.RAZORPAY.RAZOR_KEY}`, // Enter the Key ID generated from the Dashboard
          amount: this.totalAmountToPay, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
          currency: 'INR',
          name: 'Firstcry Intellitots',
          description: `${constants.RAZORPAY.FEE_TYPE.ADMISSION_FEE}`,
          image: `${constants.RAZORPAY.TOTS_IMAGE}`,
          order_id: resultantObj.data.orderID, // This is a sample Order   ID. Pass the `id` obtained in the response of Step 1
          handler: async function (response) {
            await self.postCapture(response.razorpay_payment_id)
          },
          modal: {
            ondismiss: async function () {
              await self.reject(self.orderID)
              console.log('dissmissed event in Franchisee tO BB')
            }
          },
          prefill: {
            name: self.franchisee.companyName,
            email: self.franchisee.email || 'SXXXXXXXX@gmail.com',
            contact: self.franchisee.mobileno || '99XXXXXXXXXX'
          },
          notes: {
            address: 'Razorpay Corporate Office'
          },
          theme: {
            color: `${constants.RAZORPAY.COLOR}`
          }
        }

        let rzp = new window.Razorpay(options)

        rzp.on('payment.failed', async function (response) {
          this.isError = true
          await self.reject()
          if (confirm(response.error.reason)) {
            location.reload()
          } else {
            location.reload()
          }

          // if (response && response.error.code && response.error.description) {
          //   alert(`${response.error.code} ${response.error.description}`)
          // } else {
          //   alert('Something Went Wrong ! Please try again')
          // }
        })

        rzp.open()
        event.preventDefault()
      } catch (e) {
        this.loadingComponent.close()
        await this.reject()

        const errorMessage =
          (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    walletBalanceFunc: async function () {
      try {
        this.isLoading = true
        const data = await http.get(
          `${constants.API_URL}/api/franchisee/wallet/${this.franchiseeID}`
        )
        this.isLoading = false
        this.walletBalance = data.data.openingAmount.toFixed(2)
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)

        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    walletPay: async function (event) {
      console.log(this.changeRows)
      if (this.changeRows.length === 0) {
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'Please select at least one installment',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
      if (this.totalAmountToPay <= 0) {
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'Minimum amount 1 Rupee for procced',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
      try {
        let paymentData = []

        _.map(this.changeRows, (obj) => {
          let studentOrder = { enquiryID: obj.id }
          if (!_.isEmpty(obj.checkedRows)) {
            studentOrder.assignFeeInstallmentID = obj.checkedRows
          }
          if (!_.isEmpty(obj.checkedRowsOrder)) {
            studentOrder.assignOrderID = obj.checkedRowsOrder
          }
          if (!_.isEmpty(obj.checkedRowsOrder) || !_.isEmpty(obj.checkedRows)) {
            paymentData.push(studentOrder)
          }
        })
        let payLoad = {
          franchiseeID: this.franchiseeID,
          classID: this.selectedClassID,
          serviceTypeID: '',
          academicYearID: this.academicYearID,
          amount: Number(this.totalAmountToPay),
          totalVirtualAmountOrder: Number(this.totalVirtualAmountOrder),
          assignVirtualOrderID: this.assignVirtualOrderID,
          assignKitOrderID: this.assignKitOrderID,
          students: paymentData
        }

        if (this.selectedService) {
          this.selectedClassID = ''
          payLoad.classID = null
          payLoad.serviceTypeID = this.selectedService
        }
        this.loadingComponent = this.$buefy.loading.open()
        const orderIDRes = await http.post(
          `${constants.API_URL}/api/payments/franchisee/wallet/order`,
          payLoad
        )
        this.orderID = orderIDRes.data.orderID
        this.cashCardOrderID = orderIDRes
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        await this.reject()

        const errorMessage =
          (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
      if (this.cashCardOrderID.data) {
        this.openDialog(this.dialogObj.types.payment, this.cashCardOrderID.data)
      }
    },

    openDialog (type, params) {
      console.log('trigger', type)
      this.orderID = params.id
      Object.assign(this.dialogObj, {
        id: 'WALLET',
        params,
        show: true,
        isSubTHtml: true,
        title: 'Are you sure to complete payment?',
        subtitle:
          `<p>Please click "Yes" to <b>COMPLETE</b> this payment and "No" to <b>CANCEL</b> this payment.</p>` +
          `<p>Receipt No : <b>${params.receiptNo}</b></p>`
      })
      console.log(params, 'params')
    },
    dialogClicked: async function (value) {
      switch (value.dialog.id) {
        case this.dialogObj.types.payment:
          if (value.isSuccess) {
            Object.assign(this.dialogObj, {
              isLoadingYes: true
            })
            await this.onOkay(this.dialogObj.params.orderID)
          } else {
            Object.assign(this.dialogObj, {
              isLoadingNo: true
            })
            this.orderID = this.dialogObj.params.id
            await this.reject()
          }
      }
      Object.assign(this.dialogObj, {
        show: false,
        isLoadingYes: false,
        isLoadingNo: false
      })
    },
    postCapture: async function (key) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        // this.sendCaptureRespos = await http.post(`${constants.API_URL}/api/payments/capture`, payLoad)
        this.sendCaptureRespos = await http.post(
          `${constants.API_URL}/api/payments/franchisee/capture`,
          { paymentID: key, isService: !!this.selectedService }
        )
        this.orderID = ''
        this.loadingComponent.close()
        if (this.sendCaptureRespos.data.success === 200) {
          await this.getAllInfo()
          return this.$buefy.dialog.alert({
            type: 'is-Suceess',
            message: 'Payment Captured Successfully',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        // this.sendCaptureRespos = await http.get(`${constants.API_URL}/api/invoice/${this.sendCaptureRespos.data.paymentOrderData.id}`)
        // this.isSuccess=true
        // this.$router.push({ name: 'invoice' })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        await this.reject()
        console.log('error in fetching data : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    }
  }
}
</script>
<style lang="scss" scoped>

.subtitle-text .v-card__subtitle{
   padding: 9px;
   font-size: 11px;
}
tbody {
  tr:hover {
    background-color: transparent !important;
  }
}
td,
th {
  border: 1px solid;
}
.v-data-table.theme--light .v-data-table__wrapper {
  overflow-x: hidden !important;
}
</style>
